// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class InboundControllerHubEnrollmentResponse {
    static getAttributeTypeMap() {
        return InboundControllerHubEnrollmentResponse.attributeTypeMap;
    }
}
InboundControllerHubEnrollmentResponse.discriminator = undefined;
InboundControllerHubEnrollmentResponse.additionalProperties = false;
InboundControllerHubEnrollmentResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=inboundControllerHubEnrollmentResponse.js.map